import { createContext } from "react";


export type ImageModalProps = {
  imageURL?: string;
  setImageURL: (url: string) => void;
};

const ImageModalContext = createContext<ImageModalProps>({} as ImageModalProps);

export default ImageModalContext;